var map = {
	"./1.jpg": 472,
	"./10.jpg": 2450,
	"./11.jpg": 5119,
	"./2.jpg": 455,
	"./3.webp": 7031,
	"./4.png": 1169,
	"./5.jpg": 2556,
	"./6.webp": 3480,
	"./8.jpg": 7821,
	"./9.jpg": 2928
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1685;